import type { TDatadogErrorLog } from 'utils/datadog/types'

export const CREATE_NICHE_CONTEXT_HASH_LOG: TDatadogErrorLog = {
  from: 'src/modules/brands/common/hooks/use-brand-niche-hash/index.ts',
  name: 'Create Niche Context Hash',
  message: 'Failed to create a niche context hash',
}
